export default "__VITE_ASSET__CZ48QrGe__"